export function getTranslationI(store, key) {
  return store.state.translate.translationsIframe[key] || key;
}

export function getTranslationI_G(store, key) {
  const dictKey = key + ' ' + store.state.kit.gender;
  return store.state.translate.translationsIframe[dictKey] || key;
}

export function getTranslationI_YO(store, key) {
  const dictKey = key + ' ' + store.state.kit.isYouByDNAKit;
  return store.state.translate.translationsIframe[dictKey] || key;
}

export function getTranslationI_YO_G(store, key) {
  const dictKey = key + ' ' + store.state.kit.isYouByDNAKit + ' ' + store.state.kit.gender;
  return store.state.translate.translationsIframe[dictKey] || key;
}
